import PhoneInput from './components/IntlTelInput';

export default PhoneInput;
